import { TFunction } from 'i18next';
import React, { useMemo } from 'react';
import {
  Button,
  Card,
  Group,
  NumberInput,
  TextInput,
  Select,
  Title,
  Text,
  Space,
  Grid,
  Checkbox,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { ConfiguredForm } from './formConfiguration';
import { useMediaQuery } from '@mantine/hooks';

type VideoTariffsProps = {
  form: ConfiguredForm;
  setStep: any;
};

const videoTariffsConfigs = (t: any) => ({
  description: t('videoconsultations.description'),
  description2: t('videoconsultations.description2'),
  // 15 минут, 20 минут, 30 минут, 40 минут, 1 час, 1.5 часа, 2 часа
  durationOptions: [
    { label: t('common.periods.15min'), value: '15' },
    { label: t('common.periods.20min'), value: '20' },
    { label: t('common.periods.30min'), value: '30' },
    { label: t('common.periods.40min'), value: '40' },
    { label: t('common.periods.1hour'), value: '60' },
    { label: t('common.periods.1.5hour'), value: '90' },
    { label: t('common.periods.2hour'), value: '120' },
  ],
});

export const VideoTariffs: React.FC<VideoTariffsProps> = ({ form, setStep }) => {
  const { t } = useTranslation()
  const config = useMemo(() => videoTariffsConfigs(t), [t])
  const isDesktop = useMediaQuery('(min-width: 576px)');
  const handleSubmit = () => {
    const validationResults = form.validate();
    // Different check because reasons.
    let canContinue = true;
    // That's some hacky check if error fields in format of video.0.name are present
    if (Object.keys(validationResults.errors).some(key => key.includes('video.'))) {
      canContinue = false;
    }

    if (!canContinue) return;
    // Go to next step
    form.clearErrors();
    setStep((prev: any) => prev + 1);
  };

  return (
    <>
      <Title order={3}>{t('videoconsultations.subtitle')}</Title>
      <Space h={'md'} />
      <Grid>
        {/* Required tariff */}
        <Grid.Col sm={12} lg={6} offsetLg={3}>
          <Card shadow="md" px="md">
            <Text mt="xs" size={'sm'} color={'gray'}>
              {config.description}
            </Text>
            <Text mt="xs" size={'sm'} color={'gray'}>
              {config.description2}
            </Text>
            <Space h={'md'} />
            <Select
              required
              label={t('videoconsultations.inputs.duration.label')}
              placeholder={t('videoconsultations.inputs.duration.placeholder')}
              data={config.durationOptions}
              {...form.getListInputProps('video', 0, 'duration')}
              // @ts-ignore Wrong library types for list fields.
              onFocus={() => form.clearFieldError(`video.0.duration`)}
            />
            <Space h={'md'} />
            <NumberInput
              label={t('videoconsultations.inputs.price.label')}
              placeholder={t('videoconsultations.inputs.price.placeholder')}
              required
              hideControls
              rightSection={
                <div style={{ marginRight: 16 }}>
                  <Text color="gray" size="sm">
                    €
                  </Text>
                </div>
              }
              {...form.getListInputProps('video', 0, 'price')}
              // @ts-ignore Wrong library types for list fields.
              onFocus={() => form.clearFieldError(`video.0.price`)}
            />
          </Card>
        </Grid.Col>
      </Grid>
      <Group my="xl" position="right">
        <Button size="md" fullWidth={!isDesktop} color="blue" onClick={handleSubmit}>
          {t('common.buttons.next')}
        </Button>
      </Group>
    </>
  );
};
